import { render, staticRenderFns } from "./SearchFormItem.vue?vue&type=template&id=fd643b6a&scoped=true&"
import script from "./SearchFormItem.vue?vue&type=script&lang=js&"
export * from "./SearchFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd643b6a",
  null
  
)

export default component.exports